/* eslint-disable complexity */
import { columnType } from 'components/table/types';
import _ from 'lodash';
import { Box, Stack, Switch, TextField, useTheme } from '@mui/material';
import { CustomSwitch } from 'components/Inputs';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';
import { Flag } from 'theme/elements/icons';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';

export const tableData = (data: any) => {
	return data?.map((item: any) => ({
		...item,
	}));
};

export const tableColumns = {
	bank_account_country_id: 'custom',
	code: 'string',
	currencies_code: 'custom',
	payment_type: 'custom',
	description: 'custom',
	description_he: 'custom',
	active: 'custom',
};

export const buildColumns = (
	t: any,
	saveCountryChanges: any,
	cancelCountryChanges: any,
	updateModifiedCountries: any,
	countries?: any,
	currencies?: any
): columnType[] => {
	const theme = useTheme();
	const countriesEditPermissions = hasPermission([permissionEnums.EDIT_COUNTRIES]);
	const navigate = useNavigate();
	const columns: columnType[] = [];
	const countriesObj = _.keyBy(countries, 'id');
	const currenciesObj = _.keyBy(currencies, 'code');
	_.keys(tableColumns).map((element: any, index: number) => {
		let customValueHandle = {};
		if (element === 'alpha2Code') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return <Flag title={_.lowerCase(String(value))} />;
				},
			};
		}
		if (element === 'active') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<Stack direction={'row'} justifyContent={'space-between'} gap={10}>
							<CustomSwitch checked={value} theme={theme}>
								<Switch
									checked={value}
									disabled={!row?.editable}
									onChange={
										countriesEditPermissions
											? () => updateModifiedCountries(element, !value, row)
											: undefined
									}
								/>
							</CustomSwitch>
							{row?.editable ? (
								<Stack gap={5} direction={'row'}>
									{countriesEditPermissions && (
										<>
											<img
												src={'icons/check.svg'}
												style={{
													cursor: row.name === '' ? 'auto' : 'pointer',
													opacity: row.name === '' ? 0.5 : 1,
												}}
												onClick={row.name === '' ? undefined : () => saveCountryChanges(row)}
											/>
											<img
												src={'icons/cancel.svg'}
												style={{ cursor: 'pointer' }}
												onClick={() => cancelCountryChanges()}
											/>
										</>
									)}
								</Stack>
							) : (
								<>
									{countriesEditPermissions && (
										<img
											src={'icons/pencil.svg'}
											style={{ cursor: 'pointer' }}
											onClick={() =>
												navigate('/' + pagesEnum.PAYMENTS_PURPOSE_MANAGEMENT + '/' + row.id)
											}
										/>
									)}
								</>
							)}
						</Stack>
					);
				},
			};
		}
		if (['bank_account_country_id'].includes(element)) {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return _.get(countriesObj, value)?.name || value;
				},
			};
		}
		if (['currencies_code'].includes(element)) {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return _.get(currenciesObj, value)?.name || value;
				},
			};
		}
		if (['description', 'description_he'].includes(element)) {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return <Box sx={{ width: 300, whiteSpace: 'pre-wrap' }}>{value}</Box>;
				},
			};
		}
		if (['payment_type'].includes(element)) {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return t('label.' + _.toLower(value));
				},
			};
		}
		const props: columnType = {
			fieldId: 'id',
			name: element,
			title: t('page.payments_purpose_management.field.' + element),
			type: _.get(tableColumns, element),
			sortable: true,
			...customValueHandle,
		};
		columns.push(props);
	});
	return columns;
};
